<template>
  <div class="workingHours">
    <!-- lundi mardi -->
    <div class="rowInputs">
      <div class="form-group">
        <div class="timeInput">
          <div class="checkTime">
            <argon-checkbox
              id="checkboxId"
              :checked="workingHours.Monday.working"
              @change="
                workingHours.Monday.working = !workingHours.Monday.working
              "
              >Monday</argon-checkbox
            >
          </div>

          <div class="SelectTime">
            <div class="from">
              <select
                class="form-select"
                aria-label="Default select example"
                v-model="workingHours.Monday.from"
              >
                <option selected></option>
                <option v-for="(hour, index) in hours" :key="index">
                  {{ hour }}
                </option>
              </select>
            </div>
            <div class="to">
              <select
                class="form-select"
                aria-label="Default select example"
                v-model="workingHours.Monday.to"
              >
                <option selected></option>
                <option v-for="(hour, index) in hours" :key="index">
                  {{ hour }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="timeInput">
          <div class="checkTime">
            <argon-checkbox
              id="checkboxId"
              :checked="workingHours.Tuesday.working"
              @change="
                workingHours.Tuesday.working = !workingHours.Tuesday.working
              "
              >Tuesday</argon-checkbox
            >
          </div>

          <div class="SelectTime">
            <div class="from">
              <select
                class="form-select"
                aria-label="Default select example"
                v-model="workingHours.Tuesday.from"
              >
                <option selected></option>
                <option v-for="(hour, index) in hours" :key="index">
                  {{ hour }}
                </option>
              </select>
            </div>
            <div class="to">
              <select
                class="form-select"
                aria-label="Default select example"
                v-model="workingHours.Tuesday.to"
              >
                <option selected></option>
                <option v-for="(hour, index) in hours" :key="index">
                  {{ hour }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- mercredi jeudi -->
    <div class="rowInputs">
      <div class="form-group">
        <div class="timeInput">
          <div class="checkTime">
            <argon-checkbox
              id="checkboxId"
              :checked="workingHours.Wednesday.working"
              @change="
                workingHours.Wednesday.working = !workingHours.Wednesday.working
              "
              >Wednesday</argon-checkbox
            >
          </div>

          <div class="SelectTime">
            <div class="from">
              <select
                class="form-select"
                aria-label="Default select example"
                v-model="workingHours.Wednesday.from"
              >
                <option selected></option>
                <option v-for="(hour, index) in hours" :key="index">
                  {{ hour }}
                </option>
              </select>
            </div>
            <div class="to">
              <select
                class="form-select"
                aria-label="Default select example"
                v-model="workingHours.Wednesday.to"
              >
                <option selected></option>
                <option v-for="(hour, index) in hours" :key="index">
                  {{ hour }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="timeInput">
          <div class="checkTime">
            <argon-checkbox
              id="checkboxId"
              :checked="workingHours.Thursday.working"
              @change="
                workingHours.Thursday.working = !workingHours.Thursday.working
              "
              >Thursday</argon-checkbox
            >
          </div>

          <div class="SelectTime">
            <div class="from">
              <select
                class="form-select"
                aria-label="Default select example"
                v-model="workingHours.Thursday.from"
              >
                <option selected></option>
                <option v-for="(hour, index) in hours" :key="index">
                  {{ hour }}
                </option>
              </select>
            </div>
            <div class="to">
              <select
                class="form-select"
                aria-label="Default select example"
                v-model="workingHours.Thursday.to"
              >
                <option selected></option>
                <option v-for="(hour, index) in hours" :key="index">
                  {{ hour }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- vendredi samedi -->
    <div class="rowInputs">
      <div class="form-group">
        <div class="timeInput">
          <div class="checkTime">
            <argon-checkbox
              id="checkboxId"
              :checked="workingHours.Friday.working"
              @change="
                workingHours.Friday.working = !workingHours.Friday.working
              "
              >Friday</argon-checkbox
            >
          </div>

          <div class="SelectTime">
            <div class="from">
              <select
                class="form-select"
                aria-label="Default select example"
                v-model="workingHours.Friday.from"
              >
                <option selected></option>
                <option v-for="(hour, index) in hours" :key="index">
                  {{ hour }}
                </option>
              </select>
            </div>
            <div class="to">
              <select
                class="form-select"
                aria-label="Default select example"
                v-model="workingHours.Friday.to"
              >
                <option selected></option>
                <option v-for="(hour, index) in hours" :key="index">
                  {{ hour }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="timeInput">
          <div class="checkTime">
            <argon-checkbox
              id="checkboxId"
              :checked="workingHours.Saturday.working"
              @change="
                workingHours.Saturday.working = !workingHours.Saturday.working
              "
              >Saturday</argon-checkbox
            >
          </div>

          <div class="SelectTime">
            <div class="from">
              <select
                class="form-select"
                aria-label="Default select example"
                v-model="workingHours.Saturday.from"
              >
                <option selected></option>
                <option v-for="(hour, index) in hours" :key="index">
                  {{ hour }}
                </option>
              </select>
            </div>
            <div class="to">
              <select
                class="form-select"
                aria-label="Default select example"
                v-model="workingHours.Saturday.to"
              >
                <option selected></option>
                <option v-for="(hour, index) in hours" :key="index">
                  {{ hour }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- dimanche -->
    <div class="rowInputs">
      <div class="form-group">
        <div class="timeInput">
          <div class="checkTime">
            <argon-checkbox
              id="checkboxId"
              :checked="workingHours.Sunday.working"
              @change="
                workingHours.Sunday.working = !workingHours.Sunday.working
              "
              >Sunday</argon-checkbox
            >
          </div>

          <div class="SelectTime">
            <div class="from">
              <select
                class="form-select"
                aria-label="Default select example"
                v-model="workingHours.Sunday.from"
              >
                <option selected></option>
                <option v-for="(hour, index) in hours" :key="index">
                  {{ hour }}
                </option>
              </select>
            </div>
            <div class="to">
              <select
                class="form-select"
                aria-label="Default select example"
                v-model="workingHours.Sunday.to"
              >
                <option selected></option>
                <option v-for="(hour, index) in hours" :key="index">
                  {{ hour }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group"></div>
    </div>
    <button type="submit" class="btn btn-light me-2" @click="updateCardWorkingHours">Update</button>
  </div>
</template>

<script>
import axios from 'axios'
import APIs from './../../../../config'
import ArgonCheckbox from "@/components/ArgonCheckbox.vue";
export default {
  components: {
    ArgonCheckbox,
  },
  data() {
    return {
      hours: [
        "08:00",
        "08:15",
        "08:30",
        "08:45",

        "09:00",
        "09:15",
        "09:30",
        "09:45",

        "10:00",
        "10:15",
        "10:30",
        "10:45",

        "11:00",
        "11:15",
        "11:30",
        "11:45",

        "12:00",
        "12:15",
        "12:30",
        "12:45",

        "13:00",
        "13:15",
        "13:30",
        "13:45",

        "14:00",
        "14:15",
        "14:30",
        "14:45",

        "15:00",
        "15:15",
        "15:30",
        "15:45",

        "16:00",
        "16:15",
        "16:30",
        "16:45",

        "17:00",
        "17:15",
        "17:30",
        "17:45",

        "18:00",
        "18:15",
        "18:30",
        "18:45",

        "19:00",
        "19:15",
        "19:30",
        "19:45",

        "20:00",
        "20:15",
        "20:30",
        "20:45",

        "21:00",
        "21:15",
        "21:30",
        "21:45",

        "22:00",
        "22:15",
        "22:30",
        "22:45",

        "23:00",
      ],
      workingHours: {
        Monday: {
          working: false,
          from: "",
          to: "",
        },
        Tuesday: {
          working: false,
          from: "",
          to: "",
        },
        Wednesday: {
          working: false,
          from: "",
          to: "",
        },
        Thursday: {
          working: false,
          from: "",
          to: "",
        },
        Friday: {
          working: false,
          from: "",
          to: "",
        },
        Saturday: {
          working: false,
          from: "",
          to: "",
        },
        Sunday: {
          working: false,
          from: "",
          to: "",
        },
      },
      get_token: localStorage.getItem('admin_token'),
      user_id: localStorage.getItem('admin_id')
    };
  },
    props : {
        cardInfo : Object
    },
    created() {
        console.log("heures de travail: ", this.cardInfo._id)
        this.getCurrentWorkingHours()
    },
    methods: {
      getCurrentWorkingHours() {
        this.workingHours = this.cardInfo.workingHours
      },
      updateCardWorkingHours() {
            let formData = {
              workingHours: this.workingHours,
            }
            axios.put(`${APIs.API_URL}/card/admin/cardData/${this.user_id}/${this.cardInfo._id}`, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${this.get_token}`
                }
            })
            .then(() => {
                this.$swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: "Edited",
                    showConfirmButton: false,
                    timer: 1500
                });
            })
            .catch(error => {
                this.$swal.fire({
                  position: 'top-end',
                  icon: 'error',
                  title: error.response.data.error,
                  showConfirmButton: false,
                  timer: 1500
                });
            })
      }
    }
};
</script>

<style scoped lang="scss">
.workingHours {
  background-color: white;
  padding: 2% 6%;
  border-radius: 10px;
  margin: 0% 5%;
  .rowInputs {
    display: flex;
    justify-content: space-around;
    .form-group {
      width: 45%;
    }
    .timeInput {
      display: flex;
      justify-content: space-between;
      .checkTime {
        width: 30%;
      }
      .SelectTime {
        width: 70%;
        display: flex;
        justify-content: space-between;
        .from {
          width: 40%;
        }
        .to {
          width: 40%;
        }
      }
    }
  }
}
</style>
